import { CartsActionKeys as keys } from './cartsActionKeys';
import * as types from './cartsActionTypes';
import { ICart, ICartLine, ICartLineUpdateItemRequest, ICartLineUpdateResponse } from './cartsInterfaces';

export const cartsActionCreators = {
  addItem: (payload: ICartLineUpdateItemRequest): types.AddCartItem => ({
    payload,
    type: keys.ADD_CART_ITEM
  }),
  fetchCart: (cartId: number): types.FetchCart => ({ payload: { cartId }, type: keys.FETCH_CART }),
  setCart: (payload: ICart): types.SetCart => ({ payload, type: keys.SET_CART }),
  setUpdatedCartLine: (payload: ICartLineUpdateResponse): types.SetUpdatedCartLine => ({
    payload,
    type: keys.SET_UPDATED_CART_LINE
  }),
  toggleSavingCartLine: (payload: {
    cartId: number;
    itemId: string;
    inventColorId?: string | null;
  }): types.ToggleSavingCartLine => ({
    payload,
    type: keys.TOGGLE_SAVING_CART_LINE
  }),
  updateCartLines: (payload: ICartLine[]): types.UpdateCartLines => ({ payload, type: keys.UPDATE_CART_LINES })
};
